import request from "@/utils/request";
/***
 * 企业
 */

//编辑企业账号信息
export function companyinfo(data) {
  return request({
    url: 'zwb/app/edit/companyinfo',
    method: 'post',
    data
  })
}
//企业认证
export function certifiInfo(data) {
  return request({
    url: 'zwb/app/certifi/companyinfo',
    method: 'post',
    data
  })
}
//添加资讯
export function addIndustryinfo(data) {
    return request({
      url: 'zwb/app/company/release/industryinfo',
      method: 'post',
      data
    })
}

//删除资讯
export function delIndustryinfo(params) {
    return request({
      url: 'zwb/app/company/delete/industryinfo',
      method: 'get',
      params
    })
}

//修改资讯
export function editIndustryinfo(data) {
  return request({
    url: 'zwb/app/company/modify/industryinfo',
    method: 'post',
    data
  })
}

//分页查询资讯
export function industryinfoList(data) {
    return request({
      url: 'zwb/app/industryinfo/list',
      method: 'post',
      data
    })
}

//根据id查询资讯详情
export function industryinfoDetail(params) {
    return request({ 
      url: 'zwb/app/industryinfo',
      method: 'get',
      params
    })
}
//添加案列
export function addRelease(data) {
    return request({
      url: 'zwb/app/myexample/release',
      method: 'post',
      data
    })
}
//删除案列
export function delRelease(params) {
    return request({
      url: 'zwb/app/myexample/delete',
      method: 'get',
      params
    })
}

//查询案列
export function releaseLists(data) {
  return request({
    url: 'zwb/app/example/list',
    method: 'post',
    data
  })
}

//分页查询案例
export function releaseList(data) {
    return request({
      url: 'zwb/app/myexample/list',
      method: 'post',
      data
    })
}
//修改案例
export function eidRelease(data) {
    return request({
      url: 'zwb/app/myexample/modify',
      method: 'post',
      data
    })
}
//案列详情
export function exampleInfo(params) {
    return request({
      url: 'zwb/app/example/info',
      method: 'get',
      params
    })
}




//添加供应
export function addSupply(data) {
    return request({
      url: 'zwb/app/add/supply',
      method: 'post',
      data
    })
}

//修改供应
export function editSupply(data) {
  return request({
    url: 'zwb/app/edit/supply',
    method: 'post',
    data
  })
}


//删除供应
export function delSupply(params) {
    return request({
      url: 'zwb/app/delete/supply',
      method: 'get',
      params
    })
}
//分页查询供应
export function supplyList(data) {
    return request({
      url: 'zwb/app/supply/public/list',
      method: 'post',
      data
    })
}
//分页查询供应-v2
export function supplyListV2(data) {
  return request({
    url: 'zwb/app/page/supply',
    method: 'post',
    data
  })
}
//根据id查询供应
export function getSupply(params) {
    return request({
      url: 'zwb/app/get/supply',
      method: 'get',
      params
    })
}


// export function editSupply(params) {
//     return request({
//       url: 'zwb/app/get/supply',
//       method: 'get',
//       params
//     })
// }
//查询自定义分类
export function selSupplyType(params) {
    return request({
      url: 'zwb/app/get/supply/type',
      method: 'get',
      params
    })
}

//查询供需平台系统分类
export function systemList(params) {
  return request({
    url: 'zwb/app/get/categroy/list',
    method: 'get',
    params
  })
}

//添加自定义分类
export function addSupplyType(data) {
  return request({
    url: 'zwb/app/release/supply/type',
    method: 'post',
    data
  })
}
//查询 user_id 自定义分类
export function suppType(params) {
  return request({
    url: 'zwb/app/supply/public/type/list',
    method: 'get',
    params
  })
}

//删除自定义分类
export function delsuppType(params) {
  return request({
    url: 'zwb/app/delete/supply/type',
    method: 'get',
    params
  })
}

//获取 oss 视频 上传凭证
export function getosstoken(params) {
  return request({
    url: 'zwb/app/oss/getosstoken',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/company.js